<template>
  <div class="box">

    <div v-if="greenAppData.total!=0" class="list">
      <div v-for="(item,index) of greenAppData.list" :key="index" class="item">
        <div class="item-left">
          <img v-if="item.coverPath" class="cover-img" :src="item.coverPath" alt="">
          <img v-if="!item.coverPath" class="cover-img"
            src="https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg"
            alt="">

          <div class="content">
            <span class="title">{{item.name}}.{{item.fileType}}</span>

            <div class="message">
              <div v-if="item.fileSize||item.fileSize==0" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/daxiao.png" alt="">
                <span>大小: {{(fileSize(item))}}</span>
              </div>

              <div v-if="false&&(item.browseNum||item.browseNum==0)" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/liulan.png" alt="">
                <span>浏览: {{item.browseNum}}</span>
              </div>

              <div v-if="item.downNum||item.downNum==0" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/xiazaishu.png" alt="">
                <span>下载: {{item.downNum}}</span>
              </div>

              <div v-if="false&&item.likeNum" class="message-item">
                <img width="16px" height="16px" src="~@/assets/img/resourceCenter/haoping.png" alt="">
                <span>好评: {{item.likeNum}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="citem-right">
          <div @click="downloadFile(item)" class="download">
            <el-image style="width: 24px;" :src="url"></el-image>
            <div>下载</div>
          </div>
        </div>
      </div>
    </div>

    <NoData v-else />
  </div>
</template>

<script>
import { getPersignedUrl } from "@/network/resourceRequest/api";
import NoData from "@/components/common/NoData";
import utils from "@/util/index";
export default {
  name: "ResourceList",
  components: {
    NoData
  },
  props: {
    greenAppData: {}
  },
  data() {
    return {
      url: require("@/assets/img/resourceCenter/xiazai.png")
    };
  },

  methods: {
    //下载文件--------------------------------------------
    downloadFile(item) {
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      let data = {
        //文件id--------------------------------------------
        id: item.fileId,
        //资源id--------------------------------------------
        fileResourceId: item.id,
        filename: `${item.name}.${item.fileType}`
      };

      // 发送真正的网络请求
      getPersignedUrl(data).then(res => {
        var link = document.createElement("a");
        //设置下载的文件名
        link.download = `${item.name}.${item.fileType}`;
        link.style.display = "none";
        //设置下载路径
        link.href = res.data.data;
        //触发点击
        document.body.appendChild(link);
        link.click();
        //移除节点
        document.body.removeChild(link);
      });
    },

    //文件大小
    fileSize(item) {
      let KB = parseInt(item.fileSize / 1024);
      let MB = parseInt(item.fileSize / 1024 / 1024);
      let G = parseInt(item.fileSize / 1024 / 1024 / 1024);
      if (KB < 1024) {
        return KB + "KB";
      } else if (MB < 1024) {
        return MB + "MB";
      } else if (G < 1024) {
        return G + "G";
      }
    }
  }
};
</script>

<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;

  .list {
    width: 100%;
    height: 100%;

    .item:hover {
      box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);

      transform: translateY(1px);
    }

    .item {
      display: flex;

      border-bottom: 1px solid rgba(229, 229, 229, 1);
      padding-left: 20px;
      height: 108px;

      transition: all 0.3s;

      justify-content: space-between;
      align-items: center;

      .item-left {
        display: flex;

        flex: 1;

        .cover-img {
          display: block;

          width: 68px;
          height: 68px;
        }

        .content {
          display: flex;

          margin-left: 10px;

          flex-direction: column;
          justify-content: center;

          .title {
            margin-bottom: 21px;
            height: 12px;

            font-size: 13px;
            font-weight: 400;

            color: rgba(68, 68, 68, 1);
          }

          .message {
            display: flex;

            .message-item {
              display: flex;

              margin-right: 20px;

              font-size: 12px;
              font-weight: 400;

              color: rgba(153, 153, 153, 1);

              align-items: center;

              img {
                margin-right: 4px;
              }
            }
          }
        }
      }

      .citem-right {
        display: flex;

        font-size: 12px;
        font-weight: 400;

        color: rgba(68, 68, 68, 1);

        .download {
          margin-right: 40px;

          cursor: pointer;
        }

        .push {
          margin-right: 20px;

          cursor: pointer;
        }
      }
    }
  }
}

//下载下拉框样式
.el-dropdown-menu {
  /deep/ .el-dropdown-menu__item:hover {
    color: #24ba58;
    background-color: #fff;
  }
}
</style>